import { render, staticRenderFns } from "./SettingsAccessability.vue?vue&type=template&id=8675cfb4"
import script from "./SettingsAccessability.vue?vue&type=script&lang=js"
export * from "./SettingsAccessability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports